import script from "./ProfilesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilesList.vue?vue&type=script&setup=true&lang=ts"

import "./ProfilesList.vue?vue&type=style&index=0&id=222c5939&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222c5939"]])

export default __exports__